import { LocalityState } from '@domain-group/fe-allhomes-library';
var states = Object.keys(LocalityState);
export default {
  LAND_DETAILS: {
    id: 'LAND_DETAILS',
    label: 'Overlays',
    states: ['ACT'],
    displayMapOnly: false,
    markers: ['exact', 'approximate']
  },
  GOOGLE_ROAD_MAP: {
    id: 'GOOGLE_ROAD_MAP',
    label: 'Map',
    states,
    displayMapOnly: true,
    markers: ['exact', 'approximate'],
    mapTypeId: 'roadmap'
  },
  GOOGLE_SATELLITE_MAP: {
    id: 'GOOGLE_SATELLITE_MAP',
    label: 'Satellite',
    states,
    displayMapOnly: true,
    markers: ['exact', 'approximate'],
    mapTypeId: 'hybrid'
  },
  STREET_VIEW: {
    id: 'STREET_VIEW',
    label: 'Street View',
    states,
    displayMapOnly: true,
    markers: ['exact']
  }
};